  <app-customer [formSubmitAttempted]="formState !== 'NEW'"
    (onValidChange)="customerDataValid = $event; checkValidity()"></app-customer>

  <app-object [formSubmitAttempted]="formState !== 'NEW'"
                (onValidChange)="objectDataValid = $event; checkValidity()"></app-object>

  <h2>Ihre Nachricht <span class="grey-subtext padding-left-10">(optional)</span></h2>

  <mat-form-field class="w-100" appearance="fill">
    <mat-label>Nachricht...</mat-label>
    <textarea rows="5" matInput name="remarks" [formControl]="remarkFormControl"></textarea>
    <mat-error *ngIf="remarkFormControl.invalid">Ihre Nachricht darf maximal 10.000 Zeichen lang sein</mat-error>
  </mat-form-field>

  <app-documents (selectedFiles)="files.emit($event)"></app-documents>

  <h3>Kunden-Zustimmung:</h3>
  <mat-error *ngIf="formState !== 'NEW' && !consent.checked">Bitte bestätigen Sie, dass der Kunde die Zustimmung zur Datenübermittlung gegeben hat</mat-error>
  <mat-checkbox color="primary" #consent name="consent" #consentCheckbox (change)="checkValidity()">
    Hiermit bestätige ich, dass die übermittelten Kontaktdaten vollständig und korrekt sind und der Kunde in die Übermittlung
    seiner Daten an die Dr. Klein Privatkunden AG, Hansestr. 14, 23558 Lübeck, sowie an deren angebundene Franchise- und Vermittlungspartner,
    zur weiteren Beratung per E-Mail oder Telefon eingewilligt hat.
  </mat-checkbox>

  <div class="comment">Vielen Dank für Ihre Eingaben, Sie können jetzt die Daten hier übermitteln</div>
  <div class="w-100 text-center" >
    <button mat-flat-button color="primary" *ngIf="formState !== 'SENDING'">Jetzt absenden</button>
    <button mat-flat-button disabled="true" *ngIf="formState === 'SENDING'">
      <mat-spinner style="display: inline-block" diameter="16" ></mat-spinner>&nbsp;Formular wird verarbeitet ...
    </button>
  </div>
